module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1jaGF0LWZvb3RlciB7DQoJZGlzcGxheTogZmxleDsNCglwYWRkaW5nOiAwIDAuODEyNXJlbTsNCgloZWlnaHQ6IDQuNzVyZW07DQoJYWxpZ24taXRlbXM6IGNlbnRlcjsNCglnYXA6IDAuODEyNXJlbTsNCgliYWNrZ3JvdW5kLWNvbG9yOiB3aGl0ZTsNCglib3JkZXItdG9wOiAxcHggc29saWQgJGdyZXktMjAwOw0KDQoJLnVpbi1tZXNzYWdlLWlucHV0IHsNCgkJZmxleC1ncm93OiAxOw0KCX0NCg0KCS5pbnB1dCB7DQoJCWRpc3BsYXk6IG5vbmU7DQoJfQ0KfQ0K"


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/ConversationView/ChatView/ChatFooter.scss
// module id = 2477
// module chunks = 0